import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { TokenService } from './token.service';
import { ToasterService } from './toaster.service';
import { BusinessManagementService } from './business-management.service';
import { CacheService } from './cache.service';
import { AnalyticsService } from './analytics.service';
import { BaseResponse } from '../../_models/Response';

export interface LoginFlowOptions {
  onConsent?: () => void;
  onEmailVerify?: () => void;
  logEmail?: string;
}

@Injectable({ providedIn: 'root' })
export class LoginFlowService {
  constructor(
    private authService: AuthService,
    private tokenService: TokenService,
    private router: Router,
    private toaster: ToasterService,
    private bms: BusinessManagementService,
    private cache: CacheService,
    private logger: AnalyticsService,
  ) {}

  /** Identical to LoginComponent.login()'s success handling. Reused by Sovos callback. */
  handleLoginResponse(
    response: BaseResponse,
    userid: string,
    loginFormValue?: any,
    options?: LoginFlowOptions,
  ): void {
    localStorage.setItem('mfaEnabled', response.response.mfaEnabled);

    if (response.response.mfaEnabled) {
      this.router.navigate(['/verify-mfa-otp'], {
        state: { backResp: { ...response }, loginForm: { ...(loginFormValue ?? { userid }) } },
        queryParams: { userId: userid },
      });
      return;
    }
   
      if (response.status === 1 && response.response.orgs.length >= 1) {
        localStorage.setItem('userid', userid);
        this.tokenService.setter(response.response.token, response.response.orgs, userid);
        this.authService.setLoginIndicator(1);
        this.router.navigate(['/select-organisation']);
        this.toaster.success('Successfully Logged In !');
        return;
      }

    if (response.status === 1 && response.response.orgs.length === 1) {
      if (options?.logEmail) {
        this.logger.logging('Login Success', { email: options.logEmail });
      }
      this.tokenService.setter(response.response.token, response.response.orgs, userid);
      this.authService
        .loginComplete({ token: response.response.token, orgid: response.response.orgs[0].orgId })
        .subscribe((resp: BaseResponse) => {
          if (resp.status === 1) {
            this.tokenService.setJWT(resp.response.token, response.response.orgs[0].orgId);
            this.authService.setSubscription(resp.response.subscription);
            this.bms.setActiveBusiness(null);
            this.cache.reset();
            this.bms.getMyBusiness().subscribe((res: any) => {
              localStorage.setItem('businesses', JSON.stringify(res));
              this.authService.setLoginIndicator(2);
              if (res && res.length === 1) {
                this.bms.setActiveBusiness(res[0]);
                this.router.navigateByUrl('/dashboard');
              } else {
                this.router.navigateByUrl('/select-orgianisation');
              }
            });
          }
        });
      return;
    }
    if (response.status === 0) {
      if (response.response.consentGiven === 0 && response.message === 'Consent not received from the user') {
            options?.onConsent?.();
            this.toaster.warning(response.message);
          } else if (response.response.emailVerified === 0 && response.response.consentGiven === 1 &&
            (response.message.startsWith('email.not.given'))) {
            options?.onEmailVerify?.();
            //this.toaster.warning(response.message);
          } else if (
            response.response.consentGiven === 0 &&
            (response.message.startsWith('Invalid credentials') || response.message.startsWith('Please verify'))
          ) {
            this.toaster.warning(response.message);
          }
    }else{
    if (response.response.passwordexpired) {
          this.router.navigate([`/reset-password/${userid}`]);
        } else {
          if (options?.logEmail) {
            this.logger.logging('Login Failed', { email: options.logEmail, message: response.message });
          }
          this.toaster.warning('Invalid Credentials');
        }
    }

   
    // else if (response.response.consentGiven === 0 && response.message === 'Consent not received from the user') {
    //   options?.onConsent?.();
    //   this.toaster.warning(response.message);
    // } else if (response.response.emailVerified === 0) {
    //   options?.onEmailVerify?.();
    //   //this.toaster.warning(response.message);
    // } else if (
    //   response.response.consentGiven === 0 &&
    //   (response.message.startsWith('Invalid credentials') || response.message.startsWith('Please verify'))
    // ) {
    //   this.toaster.warning(response.message);
    // } 
    
  }
}
